import $ from 'cash-dom';
import { get } from 'lodash';

const Accessibility = class {
  static trackKeyboardFocus = () => {
    document.body.addEventListener('keyup', event => {
      const element = event.target;

      if (element === document.activeElement) {
        $(element).addClass('focused');
      }
    });

    document.body.addEventListener(
      'blur',
      event => {
        $(event.target).removeClass('focused');
      },
      true
    );
  };

  static getEventTargetSelector = event => {
    const targetId = get(event, ['target', 'id']);
    const selector = targetId ? `#${targetId}` : null;

    return selector;
  };
};

export default Accessibility;
